import { useNavigate, useSearchParams } from 'react-router-dom'
import DataTable from '../Reusable/DataTable'
import APIS from '../../constant/EndPoint'
import moment from 'moment'
import useGetHook from '../../customHooks/useGetHook'
import TableActionButton from '../Reusable/TableActionButton'
import Modal from '../Reusable/Modal'
import Remark from '../Order/Remark'
import OrderHistory from '../Order/OrderHistory'
import RiderActionMenu from '../Order/RiderActionMenu'
import { classNames } from '../../utils/classNames'
import { useForm } from 'react-hook-form'
import { useState } from 'react'
import OrderActionMenu from '../Order/OrderActionMenu'
import { toast } from 'react-toastify'
import usePostHook from '../../customHooks/usePostHook'
import { queryClient } from '../../root.component'

const RiderDashboard = ({ status }: any) => {
  const navigate = useNavigate()
  const [searchParams, setSearchParms] = useSearchParams()

  const {
    register,
    setValue,
    getValues,
    watch,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({});
  const [orderActionMenu, setOrderActionMenu] = useState(false)
  const [actionType, setActionType] = useState("")
  const [openReviewModal, setOpenReviewModal] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState("")
  const [openHistoryPopup, setOpenHistoryPopup] = useState(false)

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["order"],
    navigateURL: "",
  });




  const checkedAllItems = searchParams.get("selectAllItems") === "1"

  const handleIndividualSelect = (value: string) => {
    let selectedItems = searchParams.get("selectedItems")?.split(",")
    if (!selectedItems || !selectedItems === undefined) {
      searchParams.set("selectedItems", value);
      setSearchParms(searchParams);
      return
    }
    let itemIndex = selectedItems?.findIndex((item: any) => item === value)
    if (itemIndex > -1) {
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems?.map((item: any) => item).join(",").toString()
      if (newSelectedItems.length) {
        searchParams.set("selectedItems", newSelectedItems);
      } else {
        searchParams.delete("selectedItems")
      }
      searchParams.set("selectAllItems", "0");
      setSearchParms(searchParams);
    } else {
      selectedItems?.push(value)
      const newSelectedItems = selectedItems?.map((item: any) => item).join(",").toString()
      searchParams.set("selectedItems", newSelectedItems);
      setSearchParms(searchParams);
    }
  }

  const isSelected = (value: string) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",")
    if (!selectedItems) {
      return false
    }
    return selectedItems.includes(value)
  }

  const handleSelectAll = (table: any) => {
    const { options: { data: tableData } } = table
    const isSelected = searchParams.get("selectAllItems")
    if (isSelected === "1") {
      searchParams.set("selectAllItems", "0");
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } else {
      const selectedItems = tableData?.map((item: any) => item.id).join(",").toString()
      searchParams.set("selectAllItems", "1");
      searchParams.set("selectedItems", selectedItems);
      setSearchParms(searchParams);
    }
  }


  let defaultColumns: any = [
    {
      id: 'select',
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className='cursor-pointer'
          />
        )
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className='cursor-pointer'
        />
      ),
    },
    {
      header: "WayBill",
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <div onClick={() => {
            setSelectedOrder(row?.original?.id);
            setOpenHistoryPopup(true);
          }} className={"cursor-pointer"}>
            <p className={classNames(row?.original?.is_duplicate ? "text-red-600" : "", "whitespace-nowrap")}>{getValue() ?? "N/A"}</p>
            <p className="text-xs text-gray-500">{moment(row?.original?.created).format('YY-MM-DD HH:mm:ss')}</p>
          </div>
        )
      },
    },
    {
      header: "Vendor",
      accessorKey: "vendor.id",
      cell: ({ getValue, row: { original } }: any) => {
        return (
          <p className="capitalize">{original?.is_walking_customer ? original?.sender_full_name : original?.merchant?.profile?.full_name}</p>
        )
      }
    },
    {
      header: "Destination",
      accessorKey: "destination_branch.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className="uppercase">{getValue()}</p>
            <p className="text-xs text-primary">{row?.original?.destination_branch?.warehouse?.name}</p>
          </>
        )
      },
    },
    {
      header: "Customer",
      accessorKey: "customer_full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? "N/A"}</p>
            <p className="text-xs text-gray-500">{row?.original?.customer_full_address}</p>
            <p className="text-xs text-gray-500 block">{row?.original?.customer_mobile_number1}</p>
            <p className="text-xs text-gray-500">{row?.original?.customer_mobile_number2}</p>
          </>
        )
      },
    },
    {
      header: "Finance",
      accessorKey: "delivery_charge",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className="whitespace-nowrap">COD: {row?.original?.cod ?? 0.00} </p>
            <p className="whitespace-nowrap">Collected: {row?.original?.collected_cod ?? 0.00}</p>
            <p className="whitespace-nowrap">D. Charge:{getValue()}</p>
          </>
        )
      },
    },

    {
      header: "Remarks",
      accessorKey: "remark",
      cell: ({ row, getValue }: any) => <button onClick={() => {
        setSelectedOrder(row?.original?.id)
        setOpenReviewModal(true)
      }}>
        {getValue()} Remarks
      </button>
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {

        return (
          <>
            <p className={`uppercase px-1 text-center rounded-md`} style={{ background: row?.original?.delivery_status?.color }}>{getValue()}</p>
            <p className="text-xs text-primary ">{row?.original?.rider?.name}</p>
          </>
        )
      },
    },
  ];



  const filterParams = watch()

  const { data: userProfileType } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER_PROFILE}`,
    params: {},
  });

  if (userProfileType?.is_staff) {
    defaultColumns.push({
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },)

  }


  const [cardFilterParms, setCardFilterParms] = useState<any>({})

  const handleCardFilterParams = (key: string) => {
    let params: any = {}
    let newKey = `rider_${key.toLowerCase().replaceAll(" ", "_")}`
    if (cardFilterParms[newKey]) {
      setCardFilterParms({ ...params })
    } else {
      params[newKey] = true
      setCardFilterParms({ ...params })
    }
  }
  const handleGenerateSlip = () => {
    navigate("/create-invoice")
  }

  const handleStatusUpdate = async (selectedOrder: any, data: any, setError: any) => {
    const url = `${APIS.ORDER}change-status/`;
    let formData = {
      order_ids: selectedOrder,
      status: data?.status,
      remark: data?.remark,
      collected_cod: data?.collected_cod
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setOrderActionMenu(false)
        queryClient.refetchQueries()
      }
    } catch (err) {
      toast.success("Somethings went wrong")
    }

  }

  const handleActionMenu = (data: any, type: string, setError: any) => {

    const selectedOrder = searchParams.get("selectedItems")?.split(",")
    if (!selectedOrder) {
      toast.error("Please select at least one order first")
      setOrderActionMenu(false)
      return
    }
    if (type === "Change Status") {
      handleStatusUpdate(selectedOrder, data, setError)
    }
  }



  return (
    <>
      <div className='grid grid-cols-2 gap-8 mb-4'>
        {status?.map((item: any, index: number) => (
          <div onClick={() => handleCardFilterParams(item.name)} className={`mx-auto h-32 w-32 cursor-pointer gap-2 flex-col  rounded text-white flex justify-center items-center ${item?.color}`} key={index}>
            <p>{item?.name}</p>
            <p>{item.count}</p>
          </div>
        ))}
      </div>

      <DataTable
        url={APIS.OVERVIEW_ORDER}
        queryKey={"orders"}
        columns={defaultColumns}
        addNewPagePath={userProfileType?.is_staff ? "/create-order" : userProfileType?.is_merchant ? "/create-order" : ""}
        tableName={"orders"}
        isUpload={!userProfileType?.is_rider}
        isDownload={!userProfileType?.is_rider}
        params={{
          ...filterParams,
          ...cardFilterParms,
          is_rtv: filterParams?.is_rtv ? true : null,
          order_remarks__isnull: filterParams?.order_remarks__isnull ? false : null,
          is_walking_customer: filterParams?.is_walking_customer ? true : null,
          delivery_status__in: filterParams?.delivery_status__in?.map((item: any) => (item.id)).join(",")
        }}
        actionMenu={<div className="w-full flex justify-end">
          <RiderActionMenu
            orderActionMenu={orderActionMenu}
            setOrderActionMenu={setOrderActionMenu}
            setActionType={setActionType}
            setValue={setValue}
            watch={watch}
          />
        </div>}
      />
      <Modal
        isOpen={orderActionMenu}
        setIsOpen={setOrderActionMenu}
        title={actionType}
        children={<>
          <OrderActionMenu
            handleActionMenu={handleActionMenu}
            actionType={actionType}
            isLoading={isPostLoading}
          />
        </>}
      />
      <Modal
        isOpen={openReviewModal}
        setIsOpen={setOpenReviewModal}
        title={"Remark"}
        children={<>
          <Remark
            selectedOrder={selectedOrder}
          />
        </>}
      />
      <Modal
        isOpen={openHistoryPopup}
        setIsOpen={setOpenHistoryPopup}
        title={"Order History"}
        children={<>
          <OrderHistory selectedOrder={selectedOrder} />
        </>}
      />
      {/* <div className='p-4 '>
        <Button label="Generate Deposit" onClick={handleGenerateSlip} />
      </div> */}
    </>

  )
}

export default RiderDashboard
